// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserCard-cls1___a7b1a1184c9559e3b2b{/*!*/}.UserCard-cls2__c170420666139cb207bf{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.UserCard-cls2__c170420666139cb207bf.UserCard-truncateText___e48465ec3cfcb81014d{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:168px}@media(min-width: 768px){.UserCard-cls2__c170420666139cb207bf.UserCard-truncateText___e48465ec3cfcb81014d{width:248px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserCard-cls1___a7b1a1184c9559e3b2b",
	"cls2": "UserCard-cls2__c170420666139cb207bf UserCard-cls1___a7b1a1184c9559e3b2b",
	"truncateText": "UserCard-truncateText___e48465ec3cfcb81014d"
};
export default ___CSS_LOADER_EXPORT___;
